function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 17a1 1 0 001 1h12a1 1 0 00.82-1.57L11 6.35V2H9v4.35L3.18 16.43c-.11.16-.18.36-.18.57zm1 3a3 3 0 01-3-3c0-.6.18-1.16.5-1.63L7 5.81V4a1 1 0 01-1-1V2a2 2 0 012-2h4a2 2 0 012 2v1a1 1 0 01-1 1v1.81l5.5 9.56c.32.47.5 1.03.5 1.63a3 3 0 01-3 3H4zm7-6l1.34-1.34L14.27 16H5.73l2.66-4.61L11 14zm-.5-4a.5.5 0 110 1 .5.5 0 010-1z",
  fill: "#74808F"
});
function SvgTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/test.4003c8d9.svg";
export { ForwardRef as ReactComponent };